import type { PlantPartVendor } from '@axilon-apps/domains-ontology-ui-state'

export interface SpareBadge {
  label: string
  className: string
}

export function partSpareBadge(part: {
  is_critical_spare?: boolean
  is_recommended_spare?: boolean
  is_spare?: boolean
}): SpareBadge | null {
  if (part.is_critical_spare) {
    return {
      label: 'critical spare',
      className: 'border-amber-400/40 bg-amber-500/10 text-amber-700 dark:text-amber-300'
    }
  }
  if (part.is_recommended_spare) return { label: 'recommended spare', className: '' }
  if (part.is_spare) return { label: 'spare', className: '' }
  return null
}

export function reconcileVendorChips(
  legacyVendor: string | undefined,
  vendors: readonly PlantPartVendor[]
): string | null {
  const value = legacyVendor?.trim()
  if (!value) return null
  const normalized = value.toLocaleLowerCase()
  return vendors.some((row) => row.vendor.name.trim().toLocaleLowerCase() === normalized)
    ? null
    : value
}
